'use client'

import { ContactForm } from '@/components/contact-form'
import { SectionHeader } from '@/components/section-header'
import { TallyForm } from '@/components/tally-form'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

type FormType = 'consultation' | 'document'

export const ContactSection = () => {
  const searchParams = useSearchParams()
  const formType = searchParams.get('form') as FormType | null
  const [selectedForm, setSelectedForm] = useState<FormType>(formType === 'document' ? 'document' : 'consultation')

  useEffect(() => {
    if (formType === 'consultation' || formType === 'document') {
      setSelectedForm(formType)
    }
  }, [formType])

  return (
    <section id="contact" className="w-full py-8 lg:py-16 px-4 lg:px-[240px]" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-[1440px] mx-auto">
        {/* ヘッダー部分 */}
        <div className="mb-8">
          <SectionHeader title="お問い合わせ" />
        </div>

        {/* ラジオボタングループ */}
        <div className="flex gap-4 lg:gap-8 items-center justify-center mb-8">
          {/* ご利用に関するご相談 */}
          <label className="flex gap-2 items-center cursor-pointer">
            <div className="relative flex items-center justify-center w-6 h-6">
              <input
                type="radio"
                name="contact-type"
                value="consultation"
                checked={selectedForm === 'consultation'}
                onChange={() => setSelectedForm('consultation')}
                className="appearance-none w-6 h-6 border-2 rounded-full cursor-pointer"
                style={{
                  borderColor: selectedForm === 'consultation' ? '#009CD2' : '#D7D7D7',
                }}
              />
              {selectedForm === 'consultation' && (
                <div
                  className="absolute w-3 h-3 rounded-full pointer-events-none"
                  style={{ backgroundColor: '#009CD2' }}
                />
              )}
            </div>
            <span
              className="text-sm"
              style={{
                color: selectedForm === 'consultation' ? '#009CD2' : '#363636',
                fontFamily: 'Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                fontWeight: selectedForm === 'consultation' ? 600 : 300,
                letterSpacing: '0.56px',
                lineHeight: '1.5',
              }}
            >
              ご利用に関するご相談
            </span>
          </label>

          {/* 資料請求 */}
          <label className="flex gap-2 items-center cursor-pointer">
            <div className="relative flex items-center justify-center w-6 h-6">
              <input
                type="radio"
                name="contact-type"
                value="document"
                checked={selectedForm === 'document'}
                onChange={() => setSelectedForm('document')}
                className="appearance-none w-6 h-6 border-2 rounded-full cursor-pointer"
                style={{
                  borderColor: selectedForm === 'document' ? '#009CD2' : '#D7D7D7',
                }}
              />
              {selectedForm === 'document' && (
                <div
                  className="absolute w-3 h-3 rounded-full pointer-events-none"
                  style={{ backgroundColor: '#009CD2' }}
                />
              )}
            </div>
            <span
              className="text-sm"
              style={{
                color: selectedForm === 'document' ? '#009CD2' : '#363636',
                fontFamily: 'Hiragino Kaku Gothic Pro, Meiryo, Yu Gothic, sans-serif',
                fontWeight: selectedForm === 'document' ? 600 : 300,
                letterSpacing: '0.56px',
                lineHeight: '1.5',
              }}
            >
              資料請求
            </span>
          </label>
        </div>

        {/* フォーム表示エリア */}
        <div>
          <div className={selectedForm === 'consultation' ? '' : 'hidden'}>
            <ContactForm />
          </div>
          <div className={selectedForm === 'document' ? '' : 'hidden'}>
            <TallyForm />
          </div>
        </div>
      </div>
    </section>
  )
}
